import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "rounded-2xl border border-gray-100 bg-white shadow-sm p-6 text-left" }
const _hoisted_2 = {
  key: 0,
  class: "flex items-start justify-between gap-3 mb-5"
}
const _hoisted_3 = {
  key: 0,
  class: "text-lg font-bold text-gray-900"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DetailCard',
  props: {
    title: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.title || _ctx.$slots.actions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.title)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(_ctx.title), 1))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "actions")
        ]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})